import { reportSalesCategoryTypes } from './types';
import { newDate } from "helpers/dateTools";

const { SET_REPORT_SALES_CATEGORY_FILTERS, RESTORE_INITIAL } = reportSalesCategoryTypes;

const initialState = {
  startDate: newDate(),
  endDate: newDate(),
  station: null,
};

export const reportSalesCategoryReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_REPORT_SALES_CATEGORY_FILTERS:
      return {
        ...state,
        [payload.key]: payload.value
      }
    case RESTORE_INITIAL:
      return initialState

    default:
      return state;
  }
};